import { render, staticRenderFns } from "./DeepDiveAkademie.vue?vue&type=template&id=1af149ac&scoped=true&"
import script from "./DeepDiveAkademie.vue?vue&type=script&lang=js&"
export * from "./DeepDiveAkademie.vue?vue&type=script&lang=js&"
import style0 from "./DeepDiveAkademie.vue?vue&type=style&index=0&id=1af149ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af149ac",
  null
  
)

export default component.exports